import { Component } from '@theme/component';
import { addItemToCart } from '@theme/cart-add-utility';

/**
 * Offers presentation boxes in the cart. Eligibility is decided in Liquid
 * (snippets/presentation-box-cart-state.liquid); this component only adds the box.
 *
 * @extends {Component}
 */
class CartPresentationBoxes extends Component {
  /**
   * Adds a presentation box to the cart with quantity 1.
   * @param {string} variantId - The variant ID to add.
   */
  async addBox(variantId) {
    // The loading class blocks only the mouse; a held Enter key would add the box again
    if (this.classList.contains('cart-presentation-boxes--loading')) return;
    this.classList.add('cart-presentation-boxes--loading');

    try {
      await addItemToCart(this, variantId, 'cart-presentation-boxes');
    } catch (error) {
      console.error('Error adding presentation box:', error);
    } finally {
      this.classList.remove('cart-presentation-boxes--loading');
    }
  }
}

if (!customElements.get('cart-presentation-boxes')) {
  customElements.define('cart-presentation-boxes', CartPresentationBoxes);
}
